export default {
  // Page title
  'page.title': 'Temporizador',

  // Popular timers
  'popular.title': 'Temporizadores Populares',
  'popular.10s': 'Temporizador de 10 Segundos',
  'popular.20s': 'Temporizador de 20 Segundos',
  'popular.30s': 'Temporizador de 30 Segundos',
  'popular.40s': 'Temporizador de 40 Segundos',
  'popular.50s': 'Temporizador de 50 Segundos',
  'popular.90s': 'Temporizador de 1,5 Minuto',
  'popular.2minute': 'Temporizador de 2 Minutos',
  'popular.3minute': 'Temporizador de 3 Minutos',
  'popular.5minute': 'Temporizador de 5 Minutos',
  'popular.10minute': 'Temporizador de 10 Minutos',
  'popular.15minute': 'Temporizador de 15 Minutos',
  'popular.30minute': 'Temporizador de 30 Minutos',
  'popular.60minute': 'Temporizador de 60 Minutos',
  'popular.1hour': 'Temporizador de 1 Hora',
  'popular.10hour': 'Temporizador de 10 Horas',
  'popular.24hour': 'Temporizador de 24 Horas',
  'popular.48hour': 'Temporizador de 48 Horas',

  // How to use
  'howto.title': 'Como Configurar um Temporizador',
  'howto.titleMinutes': 'Como Configurar um Temporizador de {{minutes}} Minutos',
  'howto.titleSeconds': 'Como Configurar um Temporizador de {{seconds}} Segundos',
  'howto.titleHour': 'Como Configurar um Temporizador de {{hours}} Hora',
  'howto.titleHours': 'Como Configurar um Temporizador de {{hours}} Horas',
  'howto.step1': '⚙️ Configure Seu Tempo: Clique nos números de horas ou minutos para editar o tempo diretamente. Você pode configurar até 23 horas e 59 minutos para qualquer tarefa.',
  'howto.step2': '⚡ Ajuste Rápido de Tempo: Use os botões de adição rápida para adicionar instantaneamente 30 segundos, 1 minuto, 5 minutos, 10 minutos ou 30 minutos ao seu temporizador.',
  'howto.step3': '▶️ Iniciar e Controlar: Clique em "Iniciar" para começar a contagem regressiva. Você pode pausar a qualquer momento para fazer uma pausa e retomar quando estiver pronto, ou resetar para recomeçar.',
  'howto.step4': '🔔 Receba Notificações: Receba notificações na área de trabalho e alertas sonoros personalizáveis quando o tempo acabar. Ative/desative o som no canto superior direito.',
  'howto.step5': '🖥️ Modo Tela Cheia: Clique no botão de tela cheia para cronometragem sem distrações - perfeito para apresentações, meditação ou sessões de trabalho focado.',
  'howto.step6': '📱 Funciona em Qualquer Lugar: Use em qualquer dispositivo - desktop, tablet ou celular. Não precisa baixar nada, funciona direto no seu navegador.',

  // User review submission
  'reviewSubmission.title': 'Compartilhe Sua Experiência',
  'reviewSubmission.subtitle': 'Ajude outras pessoas a descobrir este temporizador compartilhando sua experiência',
  'reviewSubmission.ratingLabel': 'Avalie sua experiência',
  'reviewSubmission.commentLabel': 'Sua avaliação (opcional)',
  'reviewSubmission.commentPlaceholder': 'Conte-nos como este temporizador ajudou você com produtividade, culinária, estudos ou outras atividades...',
  'reviewSubmission.nameLabel': 'Seu nome (opcional)',
  'reviewSubmission.namePlaceholder': 'Como devemos exibir seu nome?',
  'reviewSubmission.submitButton': 'Enviar Avaliação',
  'reviewSubmission.thankYou': 'Obrigado pela sua avaliação!',
  'reviewSubmission.thankYouMessage': 'Seu feedback nos ajuda a melhorar e ajuda outras pessoas a descobrir nosso temporizador.',
  'reviewSubmission.error': 'Por favor, selecione uma classificação antes de enviar.',

  // User reviews
  'reviews.title': 'O Que Nossos Usuários Dizem',
  'reviews.newReview': 'Nova Avaliação',
  'reviews.mikeZhang': 'Revolucionou minha produtividade! A Técnica Pomodoro com este temporizador me ajudou a terminar minha tese. Interface limpa, sem distrações.',
  'reviews.lisaLee': 'Perfeito para cronometrar na cozinha! Nunca mais cozinho ovos demais. Os alertas sonoros são altos o suficiente, mas não irritantes. Minha mãe idosa adora também.',
  'reviews.johnDeveloper': 'Melhor temporizador de pausas para programação! Os botões predefinidos economizam muito tempo. Ajuda a prevenir fadiga ocular e me mantém focado durante os sprints.',
  'reviews.msChen': 'Transformou minha gestão de sala de aula! Os alunos realmente gostam das atividades cronometradas agora. A contagem regressiva visual mantém todos engajados.',
  'reviews.fitnessPro': 'Revolucionário para treinos HIIT! Cronometragem precisa, controles fáceis mesmo com as mãos suadas. Meus clientes adoram o modo tela cheia.',
  'reviews.sarahMarketer': 'Aumentou a eficiência das minhas reuniões em 40%! Chega de discussões intermináveis. Os limites de tempo forçam decisões e mantêm todos focados.',
  'reviews.tomChef': 'Essencial na minha cozinha de restaurante! Massas, bifes, molhos - cronometragem perfeita toda vez. Os múltiplos botões de adição rápida são geniais.',
  'reviews.amyStudent': 'Mudou meu jeito de estudar! Quebra o ciclo de procrastinação com blocos de tempo gerenciáveis. Fui de notas C para A usando este método.',
  'reviews.davidWriter': 'Curou meu bloqueio de escritor! Sprints de escrita de 15 minutos criam impulso. Publiquei 3 artigos este mês graças a este temporizador.',
  'reviews.rachelTherapist': 'Perfeito para sessões de meditação com clientes. Os alertas suaves não quebram a atmosfera tranquila. Altamente profissional.',
  // Preset timer specific reviews
  'reviews.managerZhang': 'Essencial para o trabalho de escritório! Perfeito para fazer chá e pausas entre reuniões, interface limpa não distrai do trabalho.',
  'reviews.mrsLi': 'Temporizador de ovos perfeito! Ovos cozidos de 3 minutos ficam perfeitos toda vez, alertas sonoros são muito bem pensados, sem ovos cozidos demais.',
  'reviews.programmerWang': 'Essencial para exercícios oculares durante pausas na programação, 3 minutos é o tempo certo para relaxar os músculos dos olhos, ótimo para proteção da visão!',

  // Use cases
  'useCases.title': 'Casos de Uso do Temporizador de {{minutes}} Minutos',
  'useCases.titleSeconds': 'Casos de Uso do Temporizador de {{seconds}} Segundos',
  'useCases.titleHours': 'Casos de Uso do Temporizador de {{hours}} Horas',

  // Page titles
  'pageTitle': 'Temporizador de {{minutes}} Minutos',
  'pageTitleSeconds': 'Temporizador de {{seconds}} Segundos',
  'pageTitleHour': 'Temporizador de {{hours}} Hora',
  'pageTitleHours': 'Temporizador de {{hours}} Horas',

  // User names
  'user.mikeZhang': 'Mike Zhang',
  'user.lisaLee': 'Lisa Lee',
  'user.johnDeveloper': 'John Desenvolvedor',
  'user.msChen': 'Sra. Chen',
  'user.fitnessPro': 'Pro Fitness',
  'user.sarahMarketer': 'Sarah Marketing',
  'user.tomChef': 'Chef Tom',
  'user.amyStudent': 'Amy Estudante',
  'user.davidWriter': 'David Escritor',
  'user.rachelTherapist': 'Rachel Terapeuta',
  // Preset timer specific users
  'user.managerZhang': 'Gerente Zhang',
  'user.mrsLi': 'Sra. Li',
  'user.programmerWang': 'Programador Wang',

  // Use cases
  'useCases.quickBreak.title': 'Pausa Rápida',
  'useCases.quickBreak.desc': 'Pausa curta entre sessões de trabalho para refrescar a mente e prevenir esgotamento',
  'useCases.eyeCare.title': 'Lembrete de Cuidado com os Olhos',
  'useCases.eyeCare.desc': 'Siga a regra 20-20-20: a cada 20 minutos, olhe para algo a 6 metros de distância por 20 segundos',
  'useCases.teaBrewing.title': 'Preparo de Chá',
  'useCases.teaBrewing.desc': 'Tempo de infusão perfeito para chá verde (3min), chá preto (5min) ou misturas de ervas',
  'useCases.lightExercise.title': 'Exercício Leve',
  'useCases.lightExercise.desc': 'Alongamentos no escritório, yoga na mesa ou exercícios simples para combater o sedentarismo',
  'useCases.meditation.title': 'Atenção Plena e Meditação',
  'useCases.meditation.desc': 'Exercícios de respiração guiada, prática de atenção plena ou meditação para alívio do estresse',
  'useCases.softBoiledEggs.title': 'Temporizador de Cozinha',
  'useCases.softBoiledEggs.desc': 'Cronometragem perfeita para ovos cozidos (5min), cozimento de massas ou qualquer tarefa na cozinha',
  'useCases.quickReading.title': 'Leitura Focada',
  'useCases.quickReading.desc': 'Sessões de leitura concentrada para livros, artigos ou materiais de estudo',
  'useCases.phoneCall.title': 'Temporizador de Chamadas e Reuniões',
  'useCases.phoneCall.desc': 'Mantenha chamadas telefônicas no caminho certo, limite a duração das reuniões ou cronometre apresentações',
  'useCases.focusedWork.title': 'Sessões de Trabalho Pomodoro',
  'useCases.focusedWork.desc': 'Técnica Pomodoro clássica - 25 minutos de trabalho focado seguidos de uma pausa',
  'useCases.exercise.title': 'Treino e Exercício',
  'useCases.exercise.desc': 'Intervalos de alta intensidade, treino em circuito ou duração específica de exercício',
  // 15-minute specific
  'useCases.shortMeeting.title': 'Reuniões Rápidas',
  'useCases.shortMeeting.desc': 'Atualizações rápidas da equipe, reuniões diárias ou discussões colaborativas breves',
  'useCases.powerNap.title': 'Cochilo Energizante',
  'useCases.powerNap.desc': 'Duração ideal de cochilo para aumentar a energia sem sonolência',
  'useCases.learning.title': 'Sessões de Aprendizado',
  'useCases.learning.desc': 'Prática de idiomas, tutoriais de habilidades ou segmentos de vídeo educacionais',
  'useCases.creativity.title': 'Sprints Criativos',
  'useCases.creativity.desc': 'Sessões de brainstorming, sprints de escrita ou prática artística',
  // 30-minute specific
  'useCases.deepWork.title': 'Sessão de Trabalho Profundo',
  'useCases.deepWork.desc': 'Trabalho focado prolongado com interrupções mínimas para tarefas complexas',
  'useCases.workout.title': 'Treino Completo',
  'useCases.workout.desc': 'Rotina completa de exercícios, sessão de yoga ou programa de treinamento estruturado',
  'useCases.study.title': 'Bloco de Estudo',
  'useCases.study.desc': 'Sessões intensivas de estudo para exames, pesquisa ou desenvolvimento de habilidades',
  'useCases.presentation.title': 'Prática de Apresentação',
  'useCases.presentation.desc': 'Ensaie discursos, pratique pitches ou cronometre a entrega de apresentações',

  // Timer-specific user reviews
  // 1-minute timer users
  'user.officeWorkerAlex': 'Alex Escritório',
  'user.developerSarah': 'Sarah Dev',
  'user.designerMike': 'Mike Design',
  'reviews.officeWorkerAlex': 'Perfeito para pausas rápidas entre reuniões! Apenas 1 minuto para alongar e refocar faz uma enorme diferença.',
  'reviews.developerSarah': 'Ótimo para a regra 20-20-20 - a cada 20 minutos olho para algo a 6 metros de distância por 1 minuto. Meus olhos se sentem muito melhor!',
  'reviews.designerMike': 'Uso para micro-pausas durante trabalho intensivo de design. Curto, mas eficaz para prevenir esgotamento.',

  // 3-minute timer users
  'user.teaLoverEmily': 'Emily Chá',
  'user.yogatrainerJohn': 'John Yoga',
  'user.busyMomLisa': 'Lisa Mãe',
  'reviews.teaLoverEmily': 'Cronometragem perfeita para meu chá verde! 3 minutos dão o sabor perfeito sem amargor. Adoro o alerta sonoro!',
  'reviews.yogatrainerJohn': 'Uso para exercícios rápidos de respiração com clientes. 3 minutos é perfeito para uma sessão calmante.',
  'reviews.busyMomLisa': 'Ótimo para cronometrar a escovação dos dentes das crianças. Eles realmente gostam da contagem regressiva agora!',

  // 5-minute timer users
  'user.meditatorZen': 'Mestre Zen',
  'user.chefTony': 'Chef Tony',
  'user.runnerMia': 'Mia Corredora',
  'reviews.meditatorZen': 'Perfeito para meditação de iniciantes. 5 minutos é gerenciável, mas eficaz para a prática de atenção plena.',
  'reviews.chefTony': 'Essencial na minha cozinha! Cronometragem perfeita para ovos cozidos toda vez. Profissional e confiável.',
  'reviews.runnerMia': 'Uso para alongamento pós-corrida. 5 minutos garantem que não pulo minha rotina de recuperação!',

  // 10-minute timer users
  'user.studentDavid': 'David Estudante',
  'user.managerRachel': 'Rachel Gerente',
  'user.writerJames': 'James Escritor',
  'reviews.studentDavid': 'Ótimo para pausas nos estudos! 10 minutos é perfeito para resetar a mente sem perder o ritmo.',
  'reviews.managerRachel': 'Uso para sessões de leitura focada. 10 minutos de leitura ininterrupta realmente fazem diferença!',
  'reviews.writerJames': 'Perfeito para sprints cronometrados de escrita. A pressão de 10 minutos me ajuda a superar o bloqueio de escritor.',

  // 15-minute timer users
  'user.consultantAmy': 'Amy Consultora',
  'user.teacherBen': 'Ben Professor',
  'user.freelancerSophie': 'Sophie Freelancer',
  'reviews.consultantAmy': 'Ideal para chamadas rápidas com clientes e reuniões rápidas. Mantém as discussões focadas e produtivas.',
  'reviews.teacherBen': 'Uso para atividades em sala de aula e trabalho em grupo. Os alunos ficam engajados com o limite de tempo.',
  'reviews.freelancerSophie': 'Sessões Pomodoro perfeitas! 15 minutos de trabalho focado seguidos de uma pausa me mantêm produtiva o dia todo.',

  // 30-minute timer users
  'user.executiveRobert': 'Robert Executivo',
  'user.fitnessCoachMaya': 'Maya Fitness',
  'user.artistOlivia': 'Olivia Artista',
  'reviews.executiveRobert': 'Excelente para sessões de trabalho profundo. 30 minutos permitem progresso significativo sem compromisso avassalador.',
  'reviews.fitnessCoachMaya': 'Perfeito para circuitos completos de treino. Meus clientes adoram a cronometragem estruturada para diferentes exercícios.',
  'reviews.artistOlivia': 'Ótimo para sessões criativas. 30 minutos dão tempo suficiente para entrar no estado de fluxo e criar algo significativo.',
};